export default __webpack_public_path__ + "static/media/coin_flip_decision_2.3250d2d3.png";